import { AppRoutes } from '../../App/routes';
import { systemBaseRoute } from 'cb-utils/consoleRouteUtils';

export const serviceCacheRoot = 'sharedCaches';
export const serviceCacheBaseRoute = `${AppRoutes.CONSOLE_BASE_ROUTE}${systemBaseRoute}/${serviceCacheRoot}`;
